"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib"); // eslint-disable-next-line import/no-unassigned-import


require("cross-fetch/polyfill");
/** @ignore */


function fetchPrivate(input, init) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var defaultFetchOpts, fetchOpts, fetchResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            defaultFetchOpts = {
              referrer: 'no-referrer',
              referrerPolicy: 'no-referrer'
            };
            fetchOpts = Object.assign(defaultFetchOpts, init); // eslint-disable-next-line no-restricted-globals

            _context.next = 4;
            return fetch(input, fetchOpts);

          case 4:
            fetchResult = _context.sent;
            return _context.abrupt("return", fetchResult);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.fetchPrivate = fetchPrivate;